export default __webpack_public_path__ + "media/images/images/raty/star-half-3797eef81b7a3dc27b167fb846b9fd5c.png";